// extracted by mini-css-extract-plugin
export default {"durationText":"TimeSlotSelector-module__durationText___PzHof"};